import React from 'react';

export const TextIllustration = () => (
  <svg width={51} height={24} viewBox="0 0 51 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="51" height="24" rx="2" fill="black" fillOpacity="0.45" />
  </svg>
);
